import { OfferFragment } from '@occc/graphql';

import { CampaignFormValue } from '../../../types';

export const getOfferCampaignInitialValues = (
  offer?: OfferFragment,
): { campaign?: CampaignFormValue } => {
  if (!offer?.campaign?.uuid) {
    return {};
  }

  return {
    campaign: {
      uuid: offer.campaign.uuid,
      name: offer.campaign.name,
    },
  };
};
